export const STORAGE_KEYS = {
    REDIRECT_PATH: 'redirectPath',
};
